export default __webpack_public_path__ + "static/media/body-larger.c551d39a.png";